// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1YlW2","footer":"ModalUpdate_footer__2vSzM"};